<div
  class="py-2 border-b border-border-subtle"
  [id]="'conversation-' + conversation.phone">
  <div
    class="relative items-center gap-3 px-3 py-2 transition duration-150 ease-out-quart hover:bg-surface-muted active:scale-[0.99] hover:cursor-pointer rounded-lg"
    [ngClass]="{ 'bg-surface-brand-subtle': selectedConversation() }">
    <div class="flex flex-col">
      <!-- User Information -->
      <div class="flex justify-between items-start">
        <span
          class="text-base font-bold text-text"
          *ngIf="conversation.customer; else noCustomer">
          {{
            truncate(
              conversation.customer.name + ' ' + conversation.customer.last_name
            )
          }}
        </span>
        <ng-template #noCustomer>
          <!-- Sin customer vinculado se muestra el nombre del perfil de
               WhatsApp antes de caer en "Usuario no registrado" -->
          <span class="text-base font-bold text-text">{{
            conversation.name ? truncate(conversation.name) : 'Usuario no registrado'
          }}</span>
        </ng-template>
        <span class="text-sm text-text-shy">{{
          conversation.date | dateTimeFormat
        }}</span>
      </div>

      <!-- Phone and Read Status -->
      <div class="flex justify-between items-end">
        <span class="text-base text-supporting-text">{{
          conversation.phone
        }}</span>
        <span
          *ngIf="!conversation.is_read"
          class="text-right flex-auto text-[9px] animate-pop-in">
          <i class="fa-solid fa-circle text-primary-500"></i>
        </span>
      </div>

      <!-- Assistance and Bot Status -->
      <div class="flex items-center gap-2 mt-2">
        <div
          class="flex items-center text-sm"
          *ngIf="conversation.is_assistance_required">
          <div class="flex tag tagAssistance">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="currentColor">
              <path
                d="M13.5607 10.3125L7.84729 0.5625C7.40988 -0.1875 6.30604 -0.1875 5.86568 0.5625L0.154965 10.3125C-0.284589 11.0598 0.262884 12 1.14389 12H12.5707C13.4482 12 13.9973 11.0625 13.5607 10.3125ZM6.21336 3.64286C6.21336 3.28795 6.5013 3 6.85621 3C7.21113 3 7.49907 3.28929 7.49907 3.64286V7.07143C7.49907 7.42634 7.21113 7.71429 6.88032 7.71429C6.54952 7.71429 6.21336 7.42768 6.21336 7.07143V3.64286ZM6.85621 10.2857C6.39121 10.2857 6.01407 9.90857 6.01407 9.44357C6.01407 8.97857 6.39095 8.60143 6.85621 8.60143C7.32148 8.60143 7.69836 8.97857 7.69836 9.44357C7.69729 9.90804 7.32229 10.2857 6.85621 10.2857Z" />
            </svg>
            <span>Asistencia</span>
          </div>
        </div>
        <div
          class="flex items-center text-sm"
          *ngIf="conversation.is_bot_enabled === false">
          <div class="flex tag tagBot">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="12"
              viewBox="0 0 25 12"
              fill="currentColor">
              <path
                d="M23.75 6.71484C23.0137 6.71484 22.7562 7.23477 22.6941 7.33984H21.25V2.99961C21.25 1.62305 20.1289 0.5 18.75 0.5H6.25C4.875 0.5 3.75 1.62305 3.75 2.99961V7.37461H2.30586C2.24375 7.26953 1.98633 6.71484 1.25 6.71484C0.535156 6.71484 0 7.29961 0 7.96484C0 8.63125 0.535937 9.17969 1.25 9.17969C1.98633 9.17969 2.24336 8.66016 2.30586 8.58984H3.75V14.1797C3.75 15.5566 4.87305 16.6445 6.25 16.6445L8.75 16.6449V19.9258C8.75 20.3086 8.97656 20.5 9.21875 20.5C9.31258 20.5 9.40805 20.4726 9.49594 20.4091L14.375 16.7148L18.75 16.7145C20.127 16.7145 21.25 15.5914 21.25 14.2496V8.58984H22.6945C22.7578 8.73047 23.0156 9.21484 23.75 9.21484C24.4648 9.21484 25 8.63047 25 8C25 7.33203 24.4648 6.71484 23.75 6.71484ZM20 14.2148C20 14.9023 19.4375 15.4297 18.75 15.4297H14.3711C14.1005 15.4297 13.8371 15.5174 13.6207 15.6798L10 18.4336V16.125C10 15.7798 9.72016 15.5352 9.375 15.5352H6.25C5.5625 15.5352 5 14.9727 5 14.3203V11.75H20V14.2148ZM20 10.5H5V5.5H20V10.5ZM20 4.25H5V2.99961C5 2.31211 5.5625 1.78477 6.25 1.78477H18.75C19.4375 1.78477 20 2.34727 20 2.99961V4.25ZM8.75 9.21484C9.44023 9.21484 10 8.65508 10 7.96484C10 7.27461 9.44023 6.71484 8.75 6.71484C8.05977 6.71484 7.5 7.27461 7.5 7.96484C7.5 8.69141 8.05859 9.21484 8.75 9.21484ZM16.25 9.21484C16.9402 9.21484 17.5 8.65508 17.5 7.96484C17.5 7.27461 16.9402 6.71484 16.25 6.71484C15.5598 6.71484 15 7.27461 15 7.96484C15 8.69141 15.5586 9.21484 16.25 9.21484Z" />
            </svg>
            <span>Bot apagado</span>
          </div>
        </div>
        <div class="flex items-center text-sm">
          <div class="flex tag {{ conversationStep?.name }}">
            <i class="fa {{ conversationStep?.icon }}"></i>
            <span>{{ conversationStep?.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
